import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import { ICONS_ALIASES, ICONS_PALETTE } from '_constants/icons';
import { Bookkeeping_FAQ } from '_constants/faq';

import { Divider } from '_components/atomic/layouts';
import Circle from '_components/atomic/Circle';
import Dots from '_components/atomic/Dots';
import FancyList from '_components/atomic/FancyList';
import Button from '_components/atomic/Button';
import Icon from '_components/atomic/Icon';
import HowSection from '_components/composed/sections/HowSection';
import BottomNavigationSection from '_components/composed/sections/BottomNavigationSection';
import FAQSection from '_components/composed/sections/FAQSection';
import ProductBannerSection from '_components/composed/sections/ProductBannerSection';

const { colors, spaces } = theme;

const StyledBookkeepingPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const BookkeepingPage = () => {
  return (
    <StyledBookkeepingPage>
      <ProductBannerSection
        title="Bookkeeping"
        text="Bookkeeping is the process of recording financial transactions, a bookkeeping service can help businesses stay compliant and make informed financial decisions by maintaining accurate financial records and providing accurate financial reporting."
        buttonsBlock={
          <Button
            suffix={
              <Icon
                alias={ICONS_ALIASES.arrowRight}
                color={colors.indigo[600]}
              />
            }
            color={colors.white}
            textColor={colors.indigo[600]}
            hoverColor={colors.white}
            hoverTextColor={colors.indigo[600]}
          >
            Get Bookkeeping
          </Button>
        }
        backgroundImage={`${config.basePath}/images/bookkeeping-banner-background.svg`}
        desktopImage={`${config.basePath}/images/bookkeeping-banner-desktop.png`}
        mobileImage={`${config.basePath}/images/bookkeeping-banner-mobile.png`}
      />

      <Divider size={spaces.large24X} desktop />
      <Divider size={spaces.large} mobile />

      <HowSection
        title={<>Why Use a Bookkeeping Service</>}
        rightPart={
          <FancyList
            items={[
              {
                title: 'Accuracy',
                description:
                  'Bookkeeping services ensure that financial records are accurate and up-to-date, which is essential for making informed business decisions, filing taxes, and demonstrating financial stability to lenders and investors.',
                icon: ICONS_ALIASES.accuracy,
                iconPalette: ICONS_PALETTE.indigo[ICONS_ALIASES.accuracy],
                color: colors.indigo[25],
                textColor: colors.indigo[500],
              },
              {
                title: 'Save Time',
                description:
                  "Hiring a bookkeeping service frees up business owners' time so they can focus on growing and running their business, rather than being bogged down by manual bookkeeping tasks.",
                icon: ICONS_ALIASES.saveTime,
                iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.saveTime],
                color: colors.green[50],
                textColor: colors.green[500],
              },
              {
                title: 'Expertise',
                description:
                  'A Bookkeeping service brings expertise and experience to the table, which can save small businesses from costly errors and improve financial reporting, budgeting, and tax planning. They stay up to date with changing tax laws and regulations, providing their clients with valuable advice.',
                icon: ICONS_ALIASES.feedback,
                iconPalette: ICONS_PALETTE.orange[ICONS_ALIASES.feedback],
                color: colors.orange[50],
                textColor: colors.orange[500],
              },
            ]}
          />
        }
      />

      <Divider size={spaces.large24X} desktop />
      <Divider size={spaces.large} mobile />

      <FAQSection items={Bookkeeping_FAQ} />

      <Divider size={spaces.large24X} desktop />
      <Divider size={spaces.large} mobile />

      <BottomNavigationSection
        previousService={{
          title: 'Registered Agent',
          link: ROUTES.registeredAgent,
        }}
        nextService={{
          title: 'LLC Incorporation',
          link: ROUTES.llcIncorporation,
        }}
      />

      <Divider size={spaces.large24X} desktop />
      <Divider size={spaces.large} mobile />

      <Dots
        color={theme.colors.indigo[500]}
        left={290}
        top={`calc(33% + 20px)`}
      />
      <Circle
        gradient={{
          from: theme.colors.indigo[300],
          to: theme.colors.indigo[50],
        }}
        size={686}
        rotate={-90}
        left={49}
        top={`calc(26% - 20px)`}
      />

      <Dots
        color={theme.colors.indigo[500]}
        right={260}
        top={`calc(40% + 10px)`}
      />
      <Circle
        gradient={{
          from: theme.colors.indigo[300],
          to: theme.colors.indigo[50],
        }}
        size={686}
        right={-172}
        top={`calc(34% - 0px)`}
      />

      <Dots
        color={theme.colors.indigo[500]}
        left={290}
        top={`calc(70% + 10px)`}
      />
      <Circle
        gradient={{
          from: theme.colors.indigo[300],
          to: theme.colors.indigo[50],
        }}
        size={686}
        rotate={90}
        left={-134}
        top={`calc(64% + 0px)`}
      />
    </StyledBookkeepingPage>
  );
};

export default BookkeepingPage;
